/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Plans_Pay_As_You_GoInputs */

const es_admin_company_overview_plans_pay_as_you_go = /** @type {(inputs: Admin_Company_Overview_Plans_Pay_As_You_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago por uso`)
};

const en_admin_company_overview_plans_pay_as_you_go = /** @type {(inputs: Admin_Company_Overview_Plans_Pay_As_You_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay as you go`)
};

/**
* | output |
* | --- |
* | "Pay as you go" |
*
* @param {Admin_Company_Overview_Plans_Pay_As_You_GoInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_plans_pay_as_you_go = /** @type {((inputs?: Admin_Company_Overview_Plans_Pay_As_You_GoInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Plans_Pay_As_You_GoInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_plans_pay_as_you_go(inputs)
	return en_admin_company_overview_plans_pay_as_you_go(inputs)
});
export { admin_company_overview_plans_pay_as_you_go as "admin.company_overview.plans.pay_as_you_go" }